var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"background":"#fafafa"},attrs:{"fluid":""}},[_c('v-row',{staticClass:"py-12",attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","xs":"12","md":"10"}},[_c('div',{staticClass:"embedsocial-hashtag",attrs:{"data-ref":"e182912b896d637aa9eb9eecb3a2ba9dbb8235d3"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }